import { faqData } from '@/mocks/homeData';
import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            关于黄桃视频，你想知道的都在这里
          </p>
          <div className="space-y-3">
            {faqData.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl bg-background-50 border border-background-200 overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer text-left"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.q}
                  </h3>
                  <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${openIndex === idx ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-foreground-500 text-lg"></i>
                  </div>
                </button>
                {openIndex === idx && (
                  <div className="px-5 md:px-6 pb-4 animate-fade-in">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}